import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import Parser from 'html-react-parser';
import Avatar from '../common/Avatar';
import Username from '../common/Username';
import Moment from 'react-moment';
import { OverlayTrigger, Tooltip, Row, Col } from 'react-bootstrap';
import Comments from '../common/Comments';
import CodexForm from './CodexForm';
import {hasPermission} from "../common/permissions";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

class CodexDetail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            edit: false,
        };
        this.toggleEdit = this.toggleEdit.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        document.title = "Addiction | Codex | " + this.props.page.title;
    }

    handleSubmit(values) {
        this.props.editCodex(values.slug, values)
    }

    toggleEdit() {
        this.setState({edit: !this.state.edit})
    }
    

    render() {
        return (
            <div>
                <h1>{this.props.page.title}</h1>
                <div className="panel-adt clearfix">
                    {this.state.edit ? (
                        <CodexForm 
                            onSubmit={this.handleSubmit}
                            auth={this.props.auth}
                            errors={this.props.errors}
                            codex={this.props.codex}
                            editToggle={this.toggleEdit}
                            initialValues={{
                                title: this.props.page.title,
                                codex: this.props.page.body,
                                parent: this.props.page.parent ? this.props.codex.data[this.props.page.parent].id : "None",
                                order: this.props.page.order,
                                restrictionLevel: this.props.page.restrictionLevel,
                                slug: this.props.page.slug
                            }} />
                    ) : (
                        <div className="ql-snow">
                            <div className="comment ql-editor">
                                {Parser(this.props.page.body, {
                                    replace: function (domNode) {
                                        if (domNode.type === 'sup') {
                                            return React.createElement('sup', {}, 'replaced');
                                        }
                                    }
                                })}
                            </div>
                        </div>
                    )
                    }
                </div>
                <div className="panel-adt clearfix">
                    <Row>
                        <div className="pull-right">
                            {(hasPermission('publications.change_codex', this.props.auth.permissions)) || this.props.page.author === this.props.auth.currentUser.id ? (
                                <div>
                                { this.state.edit ? (
                                    <p><Button onClick={this.toggleEdit}><FontAwesomeIcon className="text-primary" icon={faEdit} fixedWidth /> Cancel</Button></p>
                                ) : (
                                    <p><Button onClick={this.toggleEdit}><FontAwesomeIcon className="text-primary" icon={faEdit} fixedWidth /> Edit</Button></p>
                                )
                                }
                                </div>
                                ) : null 
                            }
                        </div>
                        <Col md={2}>
                            <div className="avatar-img pull-left">
                                <Avatar image={this.props.users[this.props.page.author].avatar} rank={this.props.ranks[this.props.users[this.props.page.author].rank]} width="32" height="32" />
                            </div>
                            <div>
                                <Username user={this.props.users[this.props.page.author]} rank={this.props.ranks[this.props.users[this.props.page.author].rank]} placement="left" />
                                <span className="avatar-date timestamp">
                                    <OverlayTrigger placement="top" overlay={<Tooltip id="activity-feed-post-date"><Moment format="ddd MMM D YYYY">{this.props.page.created}</Moment></Tooltip>}>
                                        <Moment fromNow>{this.props.page.created}</Moment>
                                    </OverlayTrigger>
                                </span>
                            </div>
                        </Col>
                        <Col md={2}>
                            { this.props.page.lastUpdatedBy ? (
                                <div>
                                    
                                    <Username user={this.props.users[this.props.page.lastUpdatedBy]} rank={this.props.ranks[this.props.users[this.props.page.lastUpdatedBy].rank]} placement="left" />
                                    <span> updated</span>
                                    <span className="avatar-date timestamp">
                                        <OverlayTrigger placement="top" overlay={<Tooltip id="activity-feed-post-date"><Moment format="ddd MMM D YYYY">{this.props.page.lastUpdated}</Moment></Tooltip>}>
                                            <Moment fromNow>{this.props.page.lastUpdated}</Moment>
                                        </OverlayTrigger>
                                    </span>
                                </div>
                            ) : null}
                        </Col>
                    </Row>
                </div>
                <Comments minSecurity="Public" item={`/codex/${this.props.page.slug}`} />
            </div>
        )
    }
}


export default CodexDetail


// WEBPACK FOOTER //
// ./src/Media/CodexDetail.js